import { TranslateService } from "@ngx-translate/core";
import { Component, input, inject, computed } from "@angular/core";
import { Router } from "@angular/router";
import { PersonRoleDto } from "../shared/dto/person-role.dto";
import { TeaserDto } from "../shared/dto/teaser-dto";
import { CarouselComponent, SlideComponent } from "ngx-bootstrap/carousel";

@Component({
  selector: "portal-teaser",
  templateUrl: "./teaser.component.html",
  styleUrls: ["./teaser.component.scss"],
  standalone: true,
  imports: [CarouselComponent, SlideComponent],
})
export class TeaserComponent {
  readonly router = inject(Router);
  readonly translateService = inject(TranslateService);
  readonly teasers = input<TeaserDto[]>([]);
  readonly personRoles = input<PersonRoleDto[]>([]);
  readonly visibleTeasers = computed(() => {
    return this.teasers()
      .filter((it) => {
        return (
          this.router.url.includes(it.page) &&
          it.locale === this.translateService.currentLang &&
          this.personRoles()
            .map((role) => role.name)
            .includes(it.personRole)
        );
      })
      .sort((a, b) => (a.sort < b.sort ? -1 : 1));
  });
}
